import React, { useState } from 'react';
import '../styles/FAQ.scss';

const Item = ({ q, a }) => {
    const [open, setOpen] = useState(false);
    return (
        <div className={`faq-item ${open ? 'open' : ''}`} onClick={() => setOpen(!open)}>
            <div className="question">
                <h3>{q}</h3>
                <span className="toggle">{open ? '-' : '+'}</span>
            </div>
            {open && <div className="answer"><p>{a}</p></div>}
        </div>
    );
};

const FAQ = () => {
    return (
        <section className="faq">
            <div className="container">
                <h2 className="section-title">Common <span>Questions</span></h2>
                <div className="faq-list">
                    <Item q="Is space travel safe?" a="Odyssey maintains a 100% safety record with triple-redundant life support systems." />
                    <Item q="What is the training requirement?" a="All guests undergo a 3-day rapid adaptation course at our orbital station." />
                    <Item q="Can I bring my pet?" a="Small companions are welcome in our pressurized cabins, subject to quarantine checks." />
                    <Item q="Is there internet?" a="Yes, our quantum relay network provides near-instant connection back to Earth." />
                </div>
            </div>
        </section>
    );
};

export default FAQ;
